import { createTheme, IStyleFunctionOrObject } from '@fluentui/react';
import { IContactUsCurrentTheme } from './theme.model';

/**
 * Fluent UI themes to be used with ThemeProvider
 * To replace themes in themes.ts
 */

// Colors that are used for all themes
export const color = {
    gray: '#a1a1a1',
    white: '#ffffff',
    yellow: '#ffff00',
    goodStatus: '#009E00',
    stepCompleted: '#0078D4',
    stepNotStarted: '#949494',
};

export const teamsThemes: { [key: string]: IContactUsCurrentTheme } = {
    black: {
        ...createTheme({
            palette: {
                themePrimary: '#5b5fc7',
                themeLighterAlt: '#f7f7fd',
                themeLighter: '#e1e1f6',
                themeLight: '#c8c9ee',
                themeTertiary: '#5b5fc7',
                themeSecondary: '#6c6fce',
                themeDarkAlt: '#464775',
                themeDark: '#464775',
                themeDarker: '#7f85f5',
                neutralLighterAlt: '#1e1e1e',
                neutralLighter: '#1d1d1d',
                neutralLight: '#1c1c1c',
                neutralQuaternaryAlt: '#363636',
                neutralQuaternary: '#363636',
                neutralTertiaryAlt: '#181818',
                neutralTertiary: '#616161',
                neutralSecondary: '#d0d0d0',
                neutralSecondaryAlt: '#d0d0d0',
                neutralPrimaryAlt: '#363636',
                neutralPrimary: '#ffffff',
                neutralDark: '#f4f4f4',
                black: '#f8f8f8',
                white: '#1f1f1f',
                red: '#E37D80',
                blue: '#464775',
                blueDark: '#464775',
            },
            semanticColors: {
                primaryButtonBackground: '#5b5fc7 !important',
                primaryButtonBackgroundHovered: '#464775 !important',
                primaryButtonBackgroundPressed: '#464775 !important',
                primaryButtonBackgroundDisabled: '#5b5fc7 !important',
                primaryButtonBorder: '#5b5fc7  !important',
                primaryButtonText: '#ffffff',
                primaryButtonTextHovered: '#ffffff',
                primaryButtonTextPressed: '#ffffff',
                primaryButtonTextDisabled: '#ffffff',
                link: '#7f85f5 !important',
                linkHovered: '#7f85f5 !important',
                inputBackground: '#292929 !important',
                inputPlaceholderText: '#999999 !important',
                inputForegroundChecked: '#ffffff',
                inputBorder: '#1f1f1f !important',
                inputBorderHovered: '#1f1f1f !important',
                inputIcon: '#7f85f5',
            },
        }),
    },
    highcontrastblack: {
        ...createTheme({
            palette: {
                themePrimary: '#1aebff',
                themeLighterAlt: '#f6feff',
                themeLighter: '#dafcff',
                themeLight: '#baf9ff',
                themeTertiary: '#1aebff',
                themeSecondary: '#35eeff',
                themeDarkAlt: '#ffff00',
                themeDark: '#ffff00',
                themeDarker: '#ffff00',
                neutralLighterAlt: '#0b0b0b',
                neutralLighter: '#151515',
                neutralLight: '#252525',
                neutralQuaternaryAlt: '#363636',
                neutralQuaternary: '#363636',
                neutralTertiaryAlt: '#595959',
                neutralTertiary: '#616161',
                neutralSecondary: '#d0d0d0',
                neutralSecondaryAlt: '#d0d0d0',
                neutralPrimaryAlt: '#cecece',
                neutralPrimary: '#ffffff',
                neutralDark: '#f4f4f4',
                black: '#f8f8f8',
                white: '#000000',
                red: '#FFFFFF',
                blue: '#1aebff',
                blueDark: '#ffff00',
            },
            semanticColors: {
                primaryButtonBackground: '#1aebff !important',
                primaryButtonBackgroundHovered: '#ffff00 !important',
                primaryButtonBackgroundPressed: '#ffff00 !important',
                primaryButtonBackgroundDisabled: '#1aebff !important',
                primaryButtonBorder: '#1aebff !important',
                primaryButtonText: '#242424',
                primaryButtonTextHovered: '#242424',
                primaryButtonTextPressed: '#242424',
                primaryButtonTextDisabled: '#242424',
                link: '#ffff00 !important',
                linkHovered: '#ffff00 !important',
                inputBackground: '#000000',
                inputPlaceholderText: '#ffffff !important',
                inputForegroundChecked: '#242424',
                inputBorder: '#ffffff !important',
                inputBorderHovered: '#ffffff !important',
                inputIcon: '#FFFFFF',
            },
        }),
    },
    colorful: {
        ...createTheme({
            palette: {
                themePrimary: '#5b5fc7',
                themeLighterAlt: '#f7f7fd',
                themeLighter: '#e1e1f6',
                themeLight: '#c8c9ee',
                themeTertiary: '#5b5fc7',
                themeSecondary: '#6c6fce',
                themeDarkAlt: '#464775',
                themeDark: '#464775',
                themeDarker: '#5b5fc7',
                neutralLighterAlt: '#eeeeee',
                neutralLighter: '#eaeaea',
                neutralLight: '#e1e1e1',
                neutralQuaternaryAlt: '#FFFFFF',
                neutralQuaternary: '#F3F3F3',
                neutralTertiaryAlt: '#c0c0c0',
                neutralTertiary: '#616161',
                neutralSecondary: '#727272',
                neutralSecondaryAlt: '#727272',
                neutralPrimaryAlt: '#cecece',
                neutralPrimary: '#242424',
                neutralDark: '#545454',
                black: '#3c3c3c',
                white: 'transparent',
                red: '#BC2F32',
                blue: '#5b5fc7',
                blueDark: '#464775',
            },
            semanticColors: {
                primaryButtonBackground: '#5b5fc7 !important',
                primaryButtonBackgroundHovered: '#464775 !important',
                primaryButtonBackgroundPressed: '#464775 !important',
                primaryButtonBackgroundDisabled: '#5b5fc7 !important',
                primaryButtonBorder: '#5b5fc7 !important',
                primaryButtonText: '#ffffff',
                primaryButtonTextHovered: '#ffffff',
                primaryButtonTextPressed: '#ffffff',
                primaryButtonTextDisabled: '#ffffff',
                link: '#555ac0 !important',
                linkHovered: '#555ac0 !important',
                inputBackground: '#ffffff',
                inputPlaceholderText: '#707070 !important',
                inputForegroundChecked: '#ffffff',
                inputBorder: '#f5f5f5 !important',
                inputBorderHovered: '#f5f5f5 ',
                inputIcon: '#5b5fc7',
            },
        }),
    },
};

export const surfaceAppThemes: { [key: string]: IContactUsCurrentTheme } = {
    darkgray: {
        ...createTheme({
            palette: {
                themePrimary: '#373737',
                themeLighterAlt: '#f7f7f7',
                themeLighter: '#dfdfdf',
                themeLight: '#c3c3c3',
                themeTertiary: '#454545',
                themeSecondary: '#505050',
                themeDarkAlt: '#3c3c3c',
                themeDark: '#3c3c3c',
                themeDarker: '#7acbfc',
                neutralLighterAlt: '#1e1e1e',
                neutralLighter: '#1d1d1d',
                neutralLight: '#1c1c1c',
                neutralQuaternaryAlt: '#444444',
                neutralQuaternary: '#444444',
                neutralTertiaryAlt: '#181818',
                neutralTertiary: '#616161',
                neutralSecondary: '#d0d0d0',
                neutralSecondaryAlt: '#d0d0d0',
                neutralPrimaryAlt: '#ffffff',
                neutralPrimary: '#ffffff',
                neutralDark: '#f4f4f4',
                black: '#f8f8f8',
                white: '#202020',
                red: '#E37D80',
                blue: '#0067b8',
                blueDark: '#3c3c3c',
            },
            semanticColors: {
                primaryButtonBackground: '#373737 !important',
                primaryButtonBackgroundHovered: '#3c3c3c !important',
                primaryButtonBackgroundPressed: '#3c3c3c !important',
                primaryButtonBackgroundDisabled: '#373737 !important',
                primaryButtonBorder: '#454545 !important',
                primaryButtonText: '#ffffff',
                primaryButtonTextHovered: '#ffffff',
                primaryButtonTextPressed: '#ffffff',
                primaryButtonTextDisabled: '#ffffff',
                link: '#7acbfc !important',
                linkHovered: '#7acbfc !important',
                inputBackground: '#444444',
                inputForegroundChecked: '#ffffff',
                inputBorder: '#1f1f1f !important',
                inputFocusBorderAlt: '#d1e6ff !important',
                inputBorderHovered: '#1f1f1f !important',
                inputIcon: '#909090',
                inputPlaceholderText: '#eeeeee'
            },
        }),
    },
    white: {
        ...createTheme({
            palette: {
                themePrimary: '#fefefe',
                themeLighterAlt: '#e3e3e3',
                themeLighter: '#c7c7c7',
                themeLight: '#ababab',
                themeTertiary: '#d2d2d2',
                themeSecondary: '#737373',
                themeDarkAlt: '#fafafa',
                themeDark: '#fafafa',
                themeDarker: '#006cb4',
                neutralLighterAlt: '#faf9f8',
                neutralLighter: '#f3f2f1',
                neutralLight: '#edebe9',
                neutralQuaternaryAlt: '#fbfbfb',
                neutralQuaternary: '#fbfbfb',
                neutralTertiaryAlt: '#c8c6c4',
                neutralTertiary: '#616161',
                neutralSecondary: '#989898',
                neutralSecondaryAlt: '#989898',
                neutralPrimaryAlt: '#cecece',
                neutralPrimary: '#1a1a1a',
                neutralDark: '#4c4c4c',
                black: '#333333',
                white: 'transparent',
                red: '#BC2F32',
                blue: '#0067b8',
                blueDark: '#FFFFFF',
            },
            semanticColors: {
                primaryButtonBackground: '#fefefe !important',
                primaryButtonBackgroundHovered: '#fafafa !important',
                primaryButtonBackgroundPressed: '#fafafa !important',
                primaryButtonBackgroundDisabled: '#fefefe !important',
                primaryButtonBorder: '#d2d2d2 !important',
                primaryButtonText: '#1a1a1a',
                primaryButtonTextHovered: '#1a1a1a',
                primaryButtonTextPressed: '#1a1a1a',
                primaryButtonTextDisabled: '#1a1a1a',
                link: '#006cb4 !important',
                linkHovered: '#006cb4 !important',
                inputBackground: '#F3F3F3',
                inputBackgroundChecked: '#616161',
                inputForegroundChecked: '#ffffff',
                inputBorder: '#484644 !important',
                inputFocusBorderAlt: '#0079d4 !important',
                inputBorderHovered: '#484644 !important',
                inputIcon: '#0079d4',
                inputPlaceholderText: '#1a1a1a'
            },
        }),
    },
};

export const outlookDotComThemes: { [key: string]: IContactUsCurrentTheme } = {
    fluent: {
        ...createTheme({
            palette: {
                themePrimary: '#337ab7',
                themeLighterAlt: '#f5f9fc',
                themeLighter: '#d8e6f4',
                themeLight: '#b7d2ea',
                themeTertiary: '#2e6da4',
                themeSecondary: '#4687c0',
                themeDarkAlt: '#286090',
                themeDark: '#286090',
                themeDarker: '#006cb4',
                neutralLighterAlt: '#faf9f8',
                neutralLighter: '#f3f2f1',
                neutralLight: '#edebe9',
                neutralQuaternaryAlt: '#F3F3F3',
                neutralQuaternary: '#F3F3F3',
                neutralTertiaryAlt: '#c8c6c4',
                neutralTertiary: '#a1a1a1',
                neutralSecondary: '#373737',
                neutralSecondaryAlt: '#373737',
                neutralPrimaryAlt: '#cecece',
                neutralPrimary: '#242424',
                neutralDark: '#151515',
                black: '#0b0b0b',
                white: '#ffffff',
                red: '#BC2F32',
                blue: '#0067b8',
                blueDark: '#286090',
            },
            semanticColors: {
                primaryButtonBackground: '#337ab7 !important',
                primaryButtonBackgroundHovered: '#286090 !important',
                primaryButtonBackgroundPressed: '#286090 !important',
                primaryButtonBackgroundDisabled: '#337ab7 !important',
                primaryButtonBorder: '#000000 !important',
                primaryButtonText: '#ffffff',
                primaryButtonTextHovered: '#ffffff',
                primaryButtonTextPressed: '#ffffff',
                primaryButtonTextDisabled: '#ffffff',
                link: '#006cb4 !important',
                linkHovered: '#006cb4 !important',
                inputBackground: '#F3F3F3',
                inputForegroundChecked: '#ffffff',
                inputBorder: '#484644 !important',
                inputFocusBorderAlt: '#0079d4 !important',
                inputBorderHovered: '#484644 !important',
                inputIcon: '#0079d4',
            },
        }),
    },
    black: {
        ...createTheme({
            palette: {
                themePrimary: '#ffffff66',
                themeLighterAlt: '#767676',
                themeLighter: '#a6a6a6',
                themeLight: '#c8c8c8',
                themeTertiary: '#828282',
                themeSecondary: '#dadada',
                themeDarkAlt: '#2e2e2e',
                themeDark: '#2e2e2e',
                themeDarker: '#7acbfc',
                neutralLighterAlt: '#151515',
                neutralLighter: '#1e1e1e',
                neutralLight: '#2e2e2e',
                neutralQuaternaryAlt: '#363636',
                neutralQuaternary: '#363636',
                neutralTertiaryAlt: '#606060',
                neutralTertiary: '#484644',
                neutralSecondary: '#d0d0d0',
                neutralSecondaryAlt: '#d0d0d0',
                neutralPrimaryAlt: '#cecece',
                neutralPrimary: '#ffffff',
                neutralDark: '#f4f4f4',
                black: '#f8f8f8',
                white: '#0a0a0a',
                red: '#E37D80',
                blue: '#006cb4',
                blueDark: '#2e2e2e',
            },
            semanticColors: {
                primaryButtonBackground: '#ffffff66 !important',
                primaryButtonBackgroundHovered: '#2e2e2e !important',
                primaryButtonBackgroundPressed: '#2e2e2e !important',
                primaryButtonBackgroundDisabled: '#ffffff66 !important',
                primaryButtonBorder: '#ffffff !important',
                primaryButtonText: '#ffffff',
                primaryButtonTextHovered: '#ffffff',
                primaryButtonTextPressed: '#ffffff',
                primaryButtonTextDisabled: '#ffffff',
                link: '#7acbfc !important',
                linkHovered: '#7acbfc !important',
                inputBackground: '#363636',
                inputForegroundChecked: '#ffffff',
                inputBorder: '#484644 !important',
                inputFocusBorderAlt: '#d1e6ff !important',
                inputBorderHovered: '#484644 !important',
                inputIcon: '#0079d4',
            },
        }),
    },
};

export const toggleDefaultTheme: IContactUsCurrentTheme = {
    ...createTheme({
        palette: {
            themePrimary: '#337ab7',
            themeLighterAlt: '#020507',
            themeLighter: '#08141d',
            themeLight: '#0f2537',
            themeTertiary: '#2e6da4',
            themeSecondary: '#2d6ba2',
            themeDarkAlt: '#286090',
            themeDark: '#204d74',
            themeDarker: '#006cb4',
            neutralLighterAlt: '#f8f8f8',
            neutralLighter: '#f4f4f4',
            neutralLight: '#eaeaea',
            neutralQuaternaryAlt: '#F3F3F3',
            neutralQuaternary: '#F3F3F3',
            neutralTertiaryAlt: '#c8c8c8',
            neutralTertiary: '#a1a1a1',
            neutralSecondary: '#373737',
            neutralSecondaryAlt: '#373737',
            neutralPrimaryAlt: '#cecece',
            neutralPrimary: '#242424',
            neutralDark: '#151515',
            black: '#0b0b0b',
            white: '#ffffff',
            red: '#BC2F32',
            blue: '#0067b8',
            blueDark: '#122b40',
        },
        semanticColors: {
            primaryButtonBackground: '#337ab7 !important',
            primaryButtonBackgroundHovered: '#286090 !important',
            primaryButtonBackgroundPressed: '#204d74',
            primaryButtonBackgroundDisabled: '#337ab7 !important',
            primaryButtonBorder: '#000000 !important',
            primaryButtonText: '#ffffff',
            primaryButtonTextHovered: '#ffffff',
            primaryButtonTextPressed: '#ffffff',
            primaryButtonTextDisabled: '#ffffff',
            link: '#006cb4 !important',
            linkHovered: '#006cb4 !important',
            inputBackground: '#FFFFFF',
            inputForegroundChecked: '#ffffff',
            inputBorder: '#484644 !important',
            inputBorderHovered: '#484644 !important',
            inputIcon: '#0079d4',
        },
    }),
};

export const toggleColorful: IContactUsCurrentTheme = {
    ...createTheme({
        palette: {
            themePrimary: '#337ab7',
            themeLighterAlt: '#f5f9fc',
            themeLighter: '#d8e6f4',
            themeLight: '#b7d2ea',
            themeTertiary: '#337ab7',
            themeSecondary: '#4687c0',
            themeDarkAlt: '#286090',
            themeDark: '#286090',
            themeDarker: '#006cb4',
            neutralLighterAlt: '#e9e9e9',
            neutralLighter: '#e5e5e5',
            neutralLight: '#dcdcdc',
            neutralQuaternaryAlt: '#FFFFFF',
            neutralQuaternary: '#e5e5e5',
            neutralTertiaryAlt: '#bcbcbc',
            neutralTertiary: '#a1a1a1',
            neutralSecondary: '#373737',
            neutralSecondaryAlt: '#373737',
            neutralPrimaryAlt: '#cecece',
            neutralPrimary: '#242424',
            neutralDark: '#151515',
            black: '#0b0b0b',
            white: '#f0f0f0',
            red: '#BC2F32',
            blue: '#006cb4',
            blueDark: '#286090',
        },
        semanticColors: {
            primaryButtonBackground: '#337ab7 !important',
            primaryButtonBackgroundHovered: '#286090 !important',
            primaryButtonBackgroundPressed: '#286090 !important',
            primaryButtonBackgroundDisabled: '#337ab7 !important',
            primaryButtonBorder: '#000000 !important',
            primaryButtonText: '#ffffff',
            primaryButtonTextHovered: '#ffffff',
            primaryButtonTextPressed: '#ffffff',
            primaryButtonTextDisabled: '#ffffff',
            link: '#006cb4 !important',
            linkHovered: '#006cb4 !important',
            inputBackground: '#FFFFFF',
            inputForegroundChecked: '#ffffff',
            inputBorder: '#484644 !important',
            inputBorderHovered: '#484644 !important',
            inputIcon: '#0079d4',
        },
    }),
};

export const toggleDarkgray: IContactUsCurrentTheme = {
    ...createTheme({
        palette: {
            themePrimary: 'rgba(255,255,255,.4)',
            themeLighterAlt: '#767676',
            themeLighter: '#a6a6a6',
            themeLight: '#c8c8c8',
            themeTertiary: '#828282',
            themeSecondary: '#dadada',
            themeDarkAlt: '#2e2e2e',
            themeDark: '#2e2e2e',
            themeDarker: '#7acbfc',
            neutralLighterAlt: '#2d2d2d',
            neutralLighter: '#2c2c2c',
            neutralLight: '#2a2a2a',
            neutralQuaternaryAlt: '#444444',
            neutralQuaternary: '#444444',
            neutralTertiaryAlt: '#242424',
            neutralTertiary: '#484644',
            neutralSecondary: '#d0d0d0',
            neutralSecondaryAlt: '#d0d0d0',
            neutralPrimaryAlt: '#cecece',
            neutralPrimary: '#ffffff',
            neutralDark: '#f4f4f4',
            black: '#f8f8f8',
            white: '#2e2e2e',
            red: '#E37D80',
            blue: '#006cb4',
            blueDark: '#2e2e2e',
        },
        semanticColors: {
            primaryButtonBackground: '#ffffff66 !important',
            primaryButtonBackgroundHovered: '#2e2e2e !important',
            primaryButtonBackgroundPressed: '#2e2e2e !important',
            primaryButtonBackgroundDisabled: '#ffffff66 !important',
            primaryButtonBorder: '#ffffff !important',
            primaryButtonText: '#ffffff',
            primaryButtonTextHovered: '#ffffff',
            primaryButtonTextPressed: '#ffffff',
            primaryButtonTextDisabled: '#ffffff',
            link: '#7acbfc !important',
            linkHovered: '#7acbfc !important',
            inputBackground: '#444444',
            inputForegroundChecked: '#ffffff',
            inputBorder: '#484644 !important',
            inputFocusBorderAlt: '#d1e6ff !important',
            inputBorderHovered: '#484644 !important',
            inputIcon: '#d1e6ff',
        },
    }),
};

export const toggleBlack: IContactUsCurrentTheme = {
    ...createTheme({
        palette: {
            themePrimary: 'rgba(255,255,255,.4)',
            themeLighterAlt: '#767676',
            themeLighter: '#a6a6a6',
            themeLight: '#c8c8c8',
            themeTertiary: '#828282',
            themeSecondary: '#dadada',
            themeDarkAlt: '#2e2e2e',
            themeDark: '#2e2e2e',
            themeDarker: '#7acbfc',
            neutralLighterAlt: '#151515',
            neutralLighter: '#1e1e1e',
            neutralLight: '#2e2e2e',
            neutralQuaternaryAlt: '#363636',
            neutralQuaternary: '#363636',
            neutralTertiaryAlt: '#606060',
            neutralTertiary: '#484644',
            neutralSecondary: '#d0d0d0',
            neutralSecondaryAlt: '#d0d0d0',
            neutralPrimaryAlt: '#cecece',
            neutralPrimary: '#ffffff',
            neutralDark: '#f4f4f4',
            black: '#f8f8f8',
            white: '#0a0a0a',
            red: '#E37D80',
            blue: '#006cb4',
            blueDark: '#2e2e2e',
        },
        semanticColors: {
            primaryButtonBackground: '#ffffff66 !important',
            primaryButtonBackgroundHovered: '#2e2e2e !important',
            primaryButtonBackgroundPressed: '#2e2e2e !important',
            primaryButtonBackgroundDisabled: '#ffffff66 !important',
            primaryButtonBorder: '#ffffff !important',
            primaryButtonText: '#ffffff',
            primaryButtonTextHovered: '#ffffff',
            primaryButtonTextPressed: '#ffffff',
            primaryButtonTextDisabled: '#ffffff',
            link: '#7acbfc !important',
            linkHovered: '#7acbfc !important',
            inputBackground: '#444444',
            inputForegroundChecked: '#ffffff',
            inputBorder: '#484644 !important',
            inputFocusBorderAlt: '#d1e6ff !important',
            inputBorderHovered: '#484644 !important',
            inputIcon: '#d1e6ff',
        },
    }),
};

export const toggleWhite: IContactUsCurrentTheme = {
    ...createTheme({
        palette: {
            themePrimary: '#337ab7',
            themeLighterAlt: '#020507',
            themeLighter: '#08141d',
            themeLight: '#0f2537',
            themeTertiary: '#337ab7',
            themeSecondary: '#2d6ba2',
            themeDarkAlt: '#286090',
            themeDark: '#286090',
            themeDarker: '#006cb4',
            neutralLighterAlt: '#f0f0f0',
            neutralLighter: '#f1f1f1',
            neutralLight: '#edebe9',
            neutralQuaternaryAlt: '#FFFFFF',
            neutralQuaternary: '#FFFFFF',
            neutralTertiaryAlt: '#f5f5f5',
            neutralTertiary: '#a1a1a1',
            neutralSecondary: '#373737',
            neutralSecondaryAlt: '#373737',
            neutralPrimaryAlt: '#cecece',
            neutralPrimary: '#242424',
            neutralDark: '#151515',
            black: '#0b0b0b',
            white: '#f0f0f0',
            red: '#BC2F32',
            blue: '#006cb4',
            blueDark: '#286090',
        },
        semanticColors: {
            primaryButtonBackground: '#337ab7 !important',
            primaryButtonBackgroundHovered: '#286090 !important',
            primaryButtonBackgroundPressed: '#286090 !important',
            primaryButtonBackgroundDisabled: '#337ab7 !important',
            primaryButtonBorder: '#000000 !important',
            primaryButtonText: '#ffffff',
            primaryButtonTextHovered: '#ffffff',
            primaryButtonTextPressed: '#ffffff',
            primaryButtonTextDisabled: '#ffffff',
            link: '#006cb4 !important',
            linkHovered: '#006cb4 !important',
            inputBackground: '#FFFFFF',
            inputForegroundChecked: '#ffffff',
            inputBorder: '#484644 !important',
            inputBorderHovered: '#484644 !important',
            inputIcon: '#0079d4',
        },
    }),
};

export const wacThemes: { [key: string]: IContactUsCurrentTheme } = {
  white: toggleDefaultTheme,
  black: {
    ...toggleBlack,
    semanticColors: {
      ...toggleBlack.semanticColors,
      inputPlaceholderText: '#ffffff !important',
    },
  },
};

export const inAppThemes: { [key: string]: IContactUsCurrentTheme } = {
  default: toggleDefaultTheme,
  darkgray: toggleDarkgray,
  black: toggleBlack,
  white: toggleWhite,
  colorful: toggleColorful,
};

export const getToggleInAppTheme = (theme: string) => {
    let inAppThemeName = 'default';
    if (theme) {
        switch (theme.toLowerCase()) {
            case 'fluentdarkgray':
            case 'darkgray':
                inAppThemeName = 'darkgray';
                break;
            case 'fluentblack':
            case 'black':
                inAppThemeName = 'black';
                break;
            case 'fluentwhite':
            case 'white':
                inAppThemeName = 'white';
                break;
            case 'fluentcolorful':
            case 'colorful':
                inAppThemeName = 'colorful';
                break;
            default:
                break;
        }
    }

    return inAppThemes[inAppThemeName];
};

export const getTeamsTheme = (theme: string) => {
    let teamsTheme = teamsThemes['colorful'];
    if (theme) {
        teamsTheme = teamsThemes[theme.toLowerCase()] || teamsThemes['colorful'];
    }
    return teamsTheme;
};

export const getOutlookDotComTheme = (theme: string) => {
    let outlookDotComTheme = outlookDotComThemes['fluent'];
    if (!!theme) {
        outlookDotComTheme = outlookDotComThemes[theme.toLowerCase()] || outlookDotComThemes['fluent'];
    }
    return outlookDotComTheme;
};

export const getSurfaceAppTheme = (theme: string) => {
    let surfaceAppTheme = surfaceAppThemes['white'];
    if (!!theme) {
        surfaceAppTheme = surfaceAppThemes[theme.toLowerCase()] || surfaceAppThemes['white'];
    }
    return surfaceAppTheme;
};

export const getWACTheme = (theme: string) => {
  let wacTheme = wacThemes['white'];
  if (!!theme) {
    wacTheme = wacThemes[theme.toLowerCase()] || wacThemes['white'];
  }
  wacTheme.semanticColors.bodyBackground = 'transparent';
  return wacTheme;
};

export interface IThemedProp {
    theme?: IContactUsCurrentTheme;
}

export interface IStyledComponent<TStyleSet, TStyleProps extends IThemedProp = IThemedProp>
    extends IThemedProp {
    styles?: IStyleFunctionOrObject<TStyleProps, TStyleSet>
}
